import React from 'react'
import { Switch } from 'react-router-dom'
import { PublicRoute, PrivateRoute } from '../../../lib/routePermission'
import Loadable from './Loadable'

const AsyncNotFound = Loadable({
    loader: () => import('../../auth/components/pages/NotFound')
})

const AsyncLogin = Loadable({
    loader: () => import('../../auth/components/pages/Login')
})

const AsyncHomeDisplay = Loadable({
    loader: () => import('../../display/components/pages/Home')
})

const AsyncPageHeader = Loadable({
    loader: () => import('../../display/components/pages/PageHeader')
})

const AsyncPageFooter = Loadable({
    loader: () => import('../../display/components/pages/PageFooter')
})

const AsyncHomeSelectRoom = Loadable({
    loader: () => import('../../display/components/pages/HomeSelectRoom')
})

const AsyncSelectRoom = Loadable({
    loader: () => import('../../display/components/pages/SelectRoom')
})



export default () => (
    <Switch>
        <PrivateRoute exact path='/' component={AsyncHomeDisplay} />
        <PublicRoute path='/login/:path' component={AsyncLogin} />

        <PrivateRoute path='/room' component={AsyncHomeSelectRoom} />

        <PrivateRoute path='/roomheader' component={AsyncPageHeader} />
        <PrivateRoute path='/roomfooter' component={AsyncPageFooter} />

        <PrivateRoute path='/roomsplit/:key' component={AsyncSelectRoom} />

        {/* <PublicRoute exact path='/room' component={AsyncHomeSelectRoom} /> */}
        {/* <PublicRoute path='/login' component={AsyncLogin} /> */}
        {/* <PublicRoute path='/d' component={AsyncHomeDisplay} /> */}
        {/* <PrivateRoute exact path='/setting' component={AsyncSetting} />
        <PrivateRoute exact path='/allEvent' component={AsyncAllEvent} /> */}

        <PublicRoute component={AsyncNotFound} />
    </Switch>
)



// WEBPACK FOOTER //
// ./src/display/features/ui/components/Routes.js